module.exports = __webpack_public_path__ + "img/sub5.3d8058eb.png";